export default "__VITE_ASSET__CVhB5Hgh__"